"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  de: {
    shoppingLists: {
      actions: {
        insert: 'In den Warenkorb legen',
        rename: 'Umbenennen'
      },
      shoppingListsDialog: {
        title: 'Meine Einkaufslisten'
      },
      saveShoppingListDialog: {
        title: 'Die Einkaufsliste unter einem Namen speichern',
        shoppingListName: {
          label: 'Der Name der Liste',
          helperText: 'Benennen Sie Ihre Einkaufsliste. Sie können diese später dem  Namen nach identifizieren. Sie können den Namen später ändern.',
          helperTextPreview: ''
        }
      },
      shoppingListItemCollapsed: {
        quantity: 'Stück'
      }
    }
  }
};
var _default = messages;
exports.default = _default;